<template>
  <div>
	  <button v-on:click="run" :disabled="disabled2 || time > 0">{{ text }}</button>
  </div>
</template>

<script>
export default {
name: 'i-timer-btn',
 props: {
         second: {
             type: Number,
             default: 60
         },
         disabled: {
             type: Boolean,
             default: false
         }
     },
     data: function() {
         return {
             time: 0,
			 disabled2:false
         }
     },
	 mounted() {
	 	this.disabled2=this.disabled
	
	 },
     methods: {
         run: function() {
             this.$emit('run');
         },
         start: function() {
             this.time = this.second;
             this.timer();
         },
         stop: function() {
             this.time = 0;
             this.disabled2 = false;
         },
         setDisabled: function(val) {
             this.disabled2 = val;
         },
         timer: function() {
             if (this.time > 0) {
                 this.time--;
                 setTimeout(this.timer, 1000);
             } else {
                 this.disabled2 = false;
             }
         }
     },
     computed: {
         text: function() {
             return this.time > 0 ? this.time + 's 后重获取' : '获取验证码';
         }
     }
 
}
</script>

<style scoped="scoped" lang="less">
	
</style>